import { render, staticRenderFns } from "./FormInvoiceData.vue?vue&type=template&id=f138b530&"
import script from "./FormInvoiceData.vue?vue&type=script&lang=js&"
export * from "./FormInvoiceData.vue?vue&type=script&lang=js&"
import style0 from "./FormInvoiceData.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports